

function Footer() {
  return (
    <footer className="content">
        footer
    </footer>
  )
}

export default Footer